const DEPRECATED_PROP_MESSAGES = {
  size: 'Please use size prop instead',
  width: 'Please use width prop instead',
  accessibleText: 'Please use accessibleText prop instead'
};
export { DEPRECATED_PROP_MESSAGES };